import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Api from "../../Api";
import RentReceiptDisplay from "../../parts/RentReceipt";
import { Company, RentContract, RentReceipt } from "../../types";

const LegacyQuote = () => {
  const { search } = useLocation();
  const [receipt, setReceipt] = useState<RentReceipt | null>(null);
  const [contract, setContract] = useState<RentContract | null>(null);
  const [company, setCompany] = useState<Company | null>(null);

  useEffect(() => {
    Api.externalGetRentReceipt(new URLSearchParams(search).get("hash")!).then(
      ({ receipt, contract, company }) => {
        setReceipt(receipt);
        setContract(contract);
        setCompany(company);
      }
    );
  }, [search]);

  return (
    <div>
      {receipt !== null && contract !== null && company !== null && (
        <RentReceiptDisplay
          receipt={receipt}
          contract={contract}
          company={company}
        />
      )}
    </div>
  );
};

export default LegacyQuote;
